import { inject, Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { SecurePersistStateService } from '../storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  // services
  storageService = inject(SecurePersistStateService);

  private user: any;
  private institution: any;
  private institutionId: string = '';
  private institutionName: string = '';
  private keyCloakId: string | number = '';
  constructor() {}

  updateUser(jwt: any) {
    const decoded = jwtDecode(jwt);
    this.user = decoded;
    this.storageService.saveSecureData('user', decoded);
    const institution = this.user.organization;
    const { institutionName, institutionId, keyCloakId } =
      this.generateInstitutionDetails(institution);
    this.institutionName = institutionName;
    this.storageService.saveSecureData('institutionName', institutionName);
    this.institutionId = institutionId;
    this.storageService.saveSecureData('institutionId', institutionId);
    this.keyCloakId = keyCloakId;
    this.storageService.saveSecureData('keyCloakId', keyCloakId);
    this.updateInstitution(institution);
    this.storageService.saveSecureData('institution', institution);
  }

  updateInstitution(institution: any) {
    this.institution = institution;
  }

  // get user details
  get userDetails() {
    return this.user || this.storageService.getData('user');
  }

  get organizationId() {
    // Top-level JWT claim first; fall back to org attribute populated by generateInstitutionDetails
    return this.userDetails?.organisationId ?? this.getInstitutionId;
  }

  // Reads `orgId[0]` from the JWT's nested `organization.<instName>` object.
  // Falls back to `organizationId` (top-level JWT claim or institutionId)
  // when the nested orgId is missing — used by Metabase report embeds.
  get jwtOrgId(): string {
    const org = this.userDetails?.organization;
    if (org && typeof org === 'object') {
      const instName = Object.keys(org)[0];
      if (instName) {
        const orgIdArr = org[instName]?.orgId;
        const nested = Array.isArray(orgIdArr) ? orgIdArr[0] : undefined;
        if (nested) return nested;
      }
    }
    return this.organizationId ?? '';
  }

  get getInstitutionId() {
    return this.institutionId || this.storageService.getData('institutionId');
  }


  get getInstitutionName() {
    return (
      this.institutionName || this.storageService.getData('institutionName')
    );
  }

  get getKeyCloakId() {
    return this.keyCloakId || this.storageService.getData('keyCloakId');
  }

  generateInstitutionDetails(institution: any): {
    institutionName: string;
    institutionId: string;
    keyCloakId: string | number;
  } {
    if (!institution || typeof institution !== 'object') {
      return { institutionName: '', institutionId: '', keyCloakId: '' };
    }
    const instName = Object.keys(institution)[0];
    if (!instName) {
      return { institutionName: '', institutionId: '', keyCloakId: '' };
    }
    const InstDetails = institution[instName];
    return {
      institutionName: instName,
      keyCloakId: InstDetails?.id,
      institutionId: InstDetails?.orgId
        ? InstDetails?.orgId[0]
        : InstDetails?.organisationId
        ? InstDetails?.organisationId[0]
        : InstDetails?.id ?? '',
    };
  }
}
